/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  locale: string;
  slug: string;
};

/**
 * Export `fetchBanner`.
 */

export async function fetchBanner({ locale, slug }: Query): Promise<any> {
  const endpoint = getApiEndpoint('getBanners');

  try {
    const { data } = await request.get(endpoint, {
      headers: acceptLanguageHeader(locale),
      params: {
        filter: {
          page: slug
        }
      }
    });

    return data?.data;
  } catch (error) {
    handleRequestError(error);
  }
}
